var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FullCalendar',{ref:"fullCalendar",attrs:{"options":_vm.calendarOptions}})
}
var staticRenderFns = []

export { render, staticRenderFns }